<template>

<div>
    <p  @click="changeType0()" class="first_title hander"><img src="../../../assets/img/home.png"/><b>关注</b></p>


    <p v-if="webW" @click="changeType0()" class="first_title hander"><img src="../../../assets/img/home.png"/><b>关注</b></p>

    <p class="first_title hander"><img src="../../../assets/img/kankuai.png"/><b>板块</b></p>
    <div class="center" v-if="typeForumLiLoading">
        <img src="../../../assets/img/loading.gif">
        <p class="typedesc">加载中</p>
    </div>

    <div class="center" v-if="!typeForumLiLoading&&typeForumLi.length==0">
        <img src="../../../assets/img/zwsj.png" class="zwsjx">
        <p class="typedesc">暂无数据</p>
    </div>
    <p class="second_title hander"  @click="changeType(t,i)" v-for="(t,i) in typeForumLi" :key="i"><img src="../../../assets/img/yuandian.png"/>{{t.name}}<span  class="xiaoxidian" v-if="t.hasAddForum=='1'"></span></p>


    <p class="first_title hander" style="margin-top: 30px;"><img src="../../../assets/img/qunzu.png"/><b>群组</b></p>
    <div class="center" v-if="typeSubLiLoading">
        <img src="../../../assets/img/loading.gif">
        <p class="typedesc">加载中</p>
    </div>

    <div class="center" v-if="!typeSubLiLoading&&typeSubLi.length==0">
        <img src="../../../assets/img/zwsj.png" class="zwsjx">
        <p class="typedesc">暂无数据</p>
    </div>
    <p class="second_title hander"  @click="changeType2(t,i)" v-for="(t,i) in typeSubLi" :key="i"><img src="../../../assets/img/yuandian.png"/>{{t.name}}<span  class="xiaoxidian" v-if="t.hasAddForum=='1'"></span></p>


</div>

</template>

<script>


import {getTypeForumList, getTypeSubList,showAddForumTip,hideAddForumTip} from "../../../api";
import {dealResult,getWindowWidth} from "../../../api/common";
import PubSub from "pubsub-js";

export default {
    name:'ForumLeft',
    data() {
        return{
            lander:{},
            //板块信息
            typeForumLi:[],
            typeForumLiLoading:true,
            //我的群组
            typeSubLi:[],
            typeSubLiLoading:true,

            webW: true


        }
    },
    methods: {
        changeType0(){

            this.$router.push("Forum?typeId=0")
        },
        changeType2(t,index){
            this.hideAddForumTipFunc("subli",t.typeId,index)
            this.$router.push("Forum?typeId="+t.typeId)
        },
        changeType(t,index){
            this.hideAddForumTipFunc("typeli",t.id,index)
                this.$router.push("Forum?typeId="+t.id)

        },

        getTypeForumListFunc() {

            this.typeForumLiLoading=true;
            this.typeForumLi=[];
            getTypeForumList({uid: this.lander.uid, token: this.lander.token}).then((res) => {
                this.typeForumLiLoading=false;
                dealResult(res.data);
                if (res.data.status == 1) {
                    let li=res.data.obj;
                    for(let i=0;i<li.length;i++){
                        li[i].hasAddForum='0';
                    }
                    this.typeForumLi=li;
                    for(let i=0;i<li.length;i++){
                        this.showAddForumTipFunc("typeli",li[i].id,i);
                    }
                } else {
                    this.$message.error(res.data.msg)
                }


            })
        },

        getTypeSubListFunc() {
            this.typeSubLiLoading=true;
            this.typeSubLi=[];
            getTypeSubList({uid: this.lander.uid, token: this.lander.token}).then((res) => {
                this.typeSubLiLoading=false;
                dealResult(res.data);
                if (res.data.status == 1) {
                    let li=res.data.obj;
                    for(let i=0;i<li.length;i++){
                        li[i].hasAddForum='0';
                    }
                    this.typeSubLi=li;
                    for(let i=0;i<li.length;i++){
                        this.showAddForumTipFunc("subli",li[i].typeId,i);
                    }
                } else {
                    this.$message.error(res.data.msg)
                }



            })
        },

        showAddForumTipFunc(type,typeId,index) {
            showAddForumTip({uid: this.lander.uid, token: this.lander.token,typeId:typeId}).then((res) => {
                if (res.data.status == 1) {
                    if(res.data.obj=='1'){
                        if(type=='typeli') this.typeForumLi[index].hasAddForum='1';
                        if(type=='subli') this.typeSubLi[index].hasAddForum='1';
                        this.allTip();
                    }
                }
            })

        },

        hideAddForumTipFunc(type,typeId,index) {
            hideAddForumTip({uid: this.lander.uid, token: this.lander.token,typeId:typeId}).then((res) => {
                if (res.data.status == 1) {

                    if(type=='typeli') this.typeForumLi[index].hasAddForum='0';
                    if(type=='subli') this.typeSubLi[index].hasAddForum='0';

                    this.allTip();

                }
            })
        }
        ,
        allTip(){
            let all=0;

            let li=this.typeForumLi;
            for(let i=0;i<li.length;i++){
                if(li[i].hasAddForum=='1')all++;
            }
              li=this.typeSubLi;
            for(let i=0;i<li.length;i++){
                if(li[i].hasAddForum=='1')all++;
            }
            if(all>0)PubSub.publish('newForumReleasedTipAll',true);
            else PubSub.publish('newForumReleasedTipAll',false);
        }
    },mounted() {
        this.lander = JSON.parse(this.$store.state.logininfo);
        this.getTypeForumListFunc();
        this.getTypeSubListFunc();
        this.webW = getWindowWidth() < 745 ? true : false;

        //当其他人发布新帖，右边出现小红点
        PubSub.subscribe('newForumReleasedTip',(msg,forumObj)=>{
                if(forumObj.ftype=='forum'){
                    let  index = ( this.typeForumLi || []).findIndex((item) => item.id === forumObj.typeId);
                    if(index>=0){
                        this.typeForumLi[index].hasAddForum='1';
                        PubSub.publish('newForumReleasedTipAll',true);
                    }


                }
                else {
                    let  index = ( this.typeSubLi || []).findIndex((item) => item.typeId === forumObj.typeId);
                    if(index>=0) {
                        this.typeSubLi[index].hasAddForum='1';
                        PubSub.publish('newForumReleasedTipAll',true);
                    }
                }



        });
     }
};
</script>

<style scoped>






    .iconsa{
        position: absolute;
        top: 40%;
        width: 100%;
        margin:250px 0 0 0px;

        overflow: hidden;



        box-sizing: border-box;


    }
.iconsa_row{

    background: rgba(0, 0, 0, 0.3);
    padding: 10px 10px;



}
    .saitem{
        cursor: pointer;
    }
     .saitem .left{width: 50%;text-align: right;float: left;}
     .saitem .right{width: 50%;line-height: 50px;float: right;}
    .saitem .left img{width: 50px;height: 50px;}
    .saitem .right span{color: #f3f3f3;font-size: 10px;margin-left: 5px;}





</style>
